import React from 'react'
import Heading from '../shared/Heading'
import ResponsiveSlider from './ResponsiveSlider'

const ExploreMenu = () => {
  return (
    <div className='container mx-auto my-6'>
      <Heading data="EXPLORE MENU"/>
      <div className='mt-7'>
      <ResponsiveSlider />
      </div>
    </div>
  )
}

export default ExploreMenu
